<template>
  <div class="Select" :class="{ 'is--error' : error }">
    <div class="Select__container" :class="containerClass">
      <select :name="id" :id="id" @change="onChange" :required="!!required">
        <option v-if="label" value="" :disabled="!!required" :selected="modelValue == null">{{label}}</option>
        <option v-for="option in options" :key="option.value" :value="option.value" :selected="modelValue == option.value">{{ option.label || option.value }}</option>
      </select>
      <SelectArrow />
    </div>
    <div class="errors__container" v-if="error && (typeof error !== 'boolean')">
      <span v-if="error" class="error">{{ error }}</span>
      <template v-else-if="errors">
        <span v-for="error in errors" class="error">{{ error }}</span>
      </template>
    </div>
  </div>
</template>

<script>
  import SelectArrow from '@components/form/SelectArrow'
  import {watch} from "vue";

  export default {
    components: { SelectArrow },
    props : [ 'name', 'id', 'options', 'label', 'modelValue', 'required', 'containerClass', 'error', 'errors', 'resetIf', 'multiple' ],
    setup(props, context){
      watch(() => props.resetIf, (value) => {
        if (value){
          context.emit('filter-changed', null)
          context.emit('update:modelValue', null)
        }
      });
    },
    methods: {
      onChange(event){
        this.$emit('filter-changed', event.target.value)
        this.$emit('update:modelValue', event.target.value)
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/form/_Select.scss";
</style>
